import styles from "./FloatingMenu.module.scss";

export default function FloatingMenu({
  styling,
  arrowStyling,
  children,
  show = false,
}) {
  return (
    <>
      <span
        style={{ ...arrowStyling }}
        className={`${styles.arrow} ${show ? styles.show : styles.hide} `}
      />
      <div
        style={{ ...styling }}
        className={`${styles.menuContainer} ${
          show ? styles.show : styles.hide
        }`}
      >
        <div className={`${styles.content}`}>{children}</div>
      </div>
    </>
  );
}

export function MenuBody({ children, style }) {
  return (
    <div className={`${styles.menuBody}`} style={style}>
      {children}
    </div>
  );
}
